import * as React from 'react';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { className } from '@empori/util';
export function MobileTimeline(props) {
    var yearStamps = props.yearStamps;
    var _a = useState(0), activeIndex = _a[0], updateIndex = _a[1];
    if (!yearStamps) {
        return null;
    }
    useEffect(function () {
        return;
    }, [activeIndex]);
    var slides = yearStamps
        .filter(function (item) { return item.year && item.year; })
        .sort(function (a, b) {
        return new Date(a.year).getFullYear() - new Date(b.year).getFullYear();
    });
    var breakpoints = {
        0: {
            spaceBetween: 20
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'progrits-timeline-small' },
            React.createElement(Swiper, { spaceBetween: 0, onActiveIndexChange: function (index) { return updateIndex(index.activeIndex); }, breakpoints: breakpoints }, slides.map(function (stamp, index) {
                return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                    React.createElement(Slide, { stamp: stamp, activeIndex: activeIndex }));
            }))),
        React.createElement("div", { className: 'progrits-year-stamp-carousel-thumbnails' },
            React.createElement(Swiper, { spaceBetween: 0, slidesPerView: 3, onActiveIndexChange: function (index) { return updateIndex(index.activeIndex); } }, slides.map(function (stamp, index) {
                return React.createElement(SwiperSlide, { key: "slide-thumbnail-no-".concat(index + 1) },
                    React.createElement(ThumbnailItem, { index: index, activeIndex: activeIndex, stamp: stamp, updateIndex: updateIndex }));
            })))));
}
function ThumbnailItem(props) {
    var swiper = useSwiper();
    React.useEffect(function () {
        swiper.slideTo(props.activeIndex);
    }, [props.activeIndex]);
    return (React.createElement("div", { className: className('progrits-carousel-thumbnail-item', { active: props.activeIndex === props.index }), onClick: function () { return props.updateIndex(props.index); } },
        React.createElement("div", { className: 'index-indicator' },
            React.createElement("div", { className: 'dot' }),
            new Date(props.stamp.year).getFullYear())));
}
function PrevArrow(props) {
    var swiper = useSwiper();
    return (React.createElement("div", { className: className('swiper-arrow swiper-prev', { disabled: props.activeIndex === 0 }) },
        React.createElement("div", { className: 'arrow', onClick: function () { return swiper.slidePrev(); } },
            React.createElement("i", { className: 'fa-light fa-arrow-left-long' })),
        React.createElement("div", { className: 'circle' })));
}
function NextArrow(props) {
    var swiper = useSwiper();
    return (React.createElement("div", { className: className('swiper-arrow swiper-next', { disabled: props.activeIndex === props.totalSlides - 1 }) },
        React.createElement("div", { className: 'arrow', onClick: function () { return swiper.slideNext(); } },
            React.createElement("i", { className: 'fa-light fa-arrow-right-long' })),
        React.createElement("div", { className: 'circle' })));
}
function Slide(props) {
    var stamp = props.stamp;
    var swiper = useSwiper();
    React.useEffect(function () {
        swiper.slideTo(props.activeIndex);
    }, [props.activeIndex]);
    if (!stamp) {
        return null;
    }
    return (React.createElement("div", { className: className('progrits-year-content-item element-flex', { active: true }) },
        React.createElement("span", { className: 'progrits-year-top-indicator' }, new Date(props.stamp.year).getFullYear()),
        React.createElement("div", { className: 'outer-content' },
            React.createElement("div", { className: 'inner-content', dangerouslySetInnerHTML: { __html: stamp.content } }))));
}
